import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { AppContextProvider } from './context/AppContext';
import React, { useContext, Suspense } from 'react';
import Home from "./pages/Auth/Home";
import Profile from "./pages/Auth/Profile";
import SignIn from "./pages/Auth/SignIn";
import PrivateRoute from './components/PrivateRoute'
import ScrollToTop from './components/ScrollToTop';
import Loader from './components/Loader';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Error from './pages/Error';

import VehicleMake from './pages/Vehicle/Make/Index';
import VehicleModel from './pages/Vehicle/Model/Index';
import VehicleType from './pages/Vehicle/Type/Index';
import VehicleVariant from './pages/Vehicle/Variant/Index';

import Customer from './pages/User/Customer/Index';
import CustomerView from './pages/User/Customer/View';
import Activity from './pages/User/Activity';

import SubAdmin from './pages/SubAdmin/Index';
import SubAdminView from './pages/SubAdmin/View';
import SubAdminPermission from './pages/SubAdmin/Permission';

import Brand from './pages/Brand/Index';

import Specialist from './pages/User/Specialist/Index';
import SpecialistView from './pages/User/Specialist/View';

import Dealer from './pages/User/Dealer/Index';
import DealerView from './pages/User/Dealer/View';

import Banner from './pages/Banner/Index';

import Chat from './pages/Chat/Index';

import Blog from './pages/Blog/Index';
import BlogView from './pages/Blog/View';
import BlogAdd from './pages/Blog/Add';
import BlogEdit from './pages/Blog/Edit';

import Quote from './pages/Quote/Index';
import QuoteView from './pages/Quote/View';

import Service from './pages/Service/Index';

import Content from './pages/Content/Index';
import ContentView from './pages/Content/View';
import ContentEdit from './pages/Content/Edit';

import ProductCatalogue from './pages/Product/Catalogue/Index';
import ProductCatalogueView from './pages/Product/Catalogue/View';
import ProductCatalogueAdd from './pages/Product/Catalogue/Add';
import ProductCatalogueEdit from './pages/Product/Catalogue/Edit';

import ProductAttribute from './pages/Product/Attribute/Index';
import ProductAttributeView from './pages/Product/Attribute/View';
import ProductAttributeAdd from './pages/Product/Attribute/Add';
// import ProductAttributeEdit from './pages/Product/Attribute/Edit';

import Notification from './pages/Notification/Index';
import Category from './pages/Category/Index';
import Setting from './pages/Setting/Edit';

import EmailTemplate from './pages/EmailTemplate/Index';
import EmailTemplateView from './pages/EmailTemplate/View';
import EmailTemplateEdit from './pages/EmailTemplate/Edit';
import Privacy_policy from './components/PrivacyPolicy';


window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {

  return (
    <AuthProvider>
      <AppContextProvider>
        <Suspense fallback={<Loader />}>
          <BrowserRouter>
            <ScrollToTop />
            <ToastContainer closeOnClick={false} />
            <AppRoutes />
          </BrowserRouter>
        </Suspense>
      </AppContextProvider>
    </AuthProvider>
  );
}

const AppRoutes = () => {

  const { isLoggedIn } = useContext(AuthContext)

  return (
    <Routes >
      <Route path="/pimptup-admin/login" element={<SignIn />} />
      {/* <Route path="/" element={<SignIn />} /> */}
      <Route exact path="/pimptup-admin/content-privacy-policy" element={<Privacy_policy />} />
.
      <Route
        path="/pimptup-admin/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>}
      >
        {/* Auth Routes */}
        <Route exact path="/pimptup-admin/" element={<Home />} />
        <Route exact path="/pimptup-admin/dashboard" element={<Home />} />
        <Route exact path="/pimptup-admin/profile" element={<Profile />} />

        {/* Dealer Routes */}
        <Route exact path="/pimptup-admin/user/dealer" element={<Dealer />} />
        <Route exact path="/pimptup-admin/user/dealer/view/:id" element={<DealerView />} />

        {/* Customer Routes */}
        <Route exact path="/pimptup-admin/user/customer" element={<Customer />} />
        <Route exact path="/pimptup-admin/user/customer/view/:id" element={<CustomerView />} />
        <Route exact path="/pimptup-admin/user/activity/:id" element={<Activity />} />

        {/* Specialist Routes */}
        <Route exact path="/pimptup-admin/user/specialist" element={<Specialist />} />
        <Route exact path="/pimptup-admin/user/specialist/view/:id" element={<SpecialistView />} />

        {/* Specialist Routes */}
        <Route exact path="/pimptup-admin/sub-admin" element={<SubAdmin />} />
        <Route exact path="/pimptup-admin/sub-admin/view/:id" element={<SubAdminView />} />
        <Route exact path="/pimptup-admin/sub-admin/permission/:id" element={<SubAdminPermission />} />

        {/* Vehicle Make Model Type Routes */}
        <Route exact path="/pimptup-admin/vehicle/make" element={<VehicleMake />} />
        <Route exact path="/pimptup-admin/vehicle/model" element={<VehicleModel />} />
        <Route exact path="/pimptup-admin/vehicle/type" element={<VehicleType />} />
        <Route exact path="/pimptup-admin/vehicle/variant" element={<VehicleVariant />} />

        {/* Services Routes */}
        <Route exact path="/pimptup-admin/service" element={<Service />} />

        {/* Banner Routes */}
        <Route exact path="/pimptup-admin/banner" element={<Banner />} />

        {/* Content Routes */}
        <Route exact path="/pimptup-admin/content" element={<Content />} />
        <Route exact path="/pimptup-admin/content/update/:slug?" element={<ContentEdit />} />
        <Route exact path="/pimptup-admin/content/view/:slug" element={<ContentView />} />

        {/* Quote Routes */}
        <Route exact path="/pimptup-admin/quote" element={<Quote />} />
        <Route exact path="/pimptup-admin/quote/view/:id" element={<QuoteView />} />

        {/* Message/Chat Routes */}
        <Route exact path="/pimptup-admin/chat" element={<Chat />} />

        {/* Blog Routes */}
        <Route exact path="/pimptup-admin/blog" element={<Blog />} />
        <Route exact path="/pimptup-admin/blog/add" element={<BlogAdd />} />
        <Route exact path="/pimptup-admin/blog/update/:id?" element={<BlogEdit />} />
        <Route exact path="/pimptup-admin/blog/view/:id" element={<BlogView />} />

        {/* ProductCatalogue Routes */}
        <Route exact path="/pimptup-admin/product/catalogue" element={<ProductCatalogue />} />
        <Route exact path="/pimptup-admin/product/catalogue/add" element={<ProductCatalogueAdd />} />
        <Route exact path="/pimptup-admin/product/catalogue/update/:id?" element={<ProductCatalogueEdit />} />
        <Route exact path="/pimptup-admin/product/catalogue/view/:id" element={<ProductCatalogueView />} />

        {/* ProductAttribute Routes */}
        <Route exact path="/pimptup-admin/product/attribute" element={<ProductAttribute />} />
        <Route exact path="/pimptup-admin/product/attribute/add" element={<ProductAttributeAdd />} />
        <Route exact path="/pimptup-admin/product/attribute/update/:id?" element={<ProductAttributeAdd />} />
        <Route exact path="/pimptup-admin/product/attribute/view/:id" element={<ProductAttributeView />} />

        {/* Brand Routes */}
        <Route exact path="/pimptup-admin/brand" element={<Brand />} />

        {/* EmailTemplate Routes */}
        <Route exact path="/pimptup-admin/email-template" element={<EmailTemplate />} />
        <Route exact path="/pimptup-admin/email-template/update/:id?" element={<EmailTemplateEdit />} />
        <Route exact path="/pimptup-admin/email-template/view/:id" element={<EmailTemplateView />} />

        {/* Setting Routes */}
        <Route exact path="/pimptup-admin/setting" element={<Setting />} />

        {/* Category Routes */}
        <Route exact path="/pimptup-admin/category/:type" element={<Category />} />

        {/* Notification Routes */}
        <Route exact path="/pimptup-admin/notification" element={<Notification />} />

      </Route >

      <Route path="*" element={<Error />} />
    </Routes >
  )
}

const Layout = () => {
  return (<> <Outlet />  </>
  )
}

// function App() {
//   const { isLoggedIn } = useContext(AuthContext)
//   return (
//     <div className="App">
//       <BrowserRouter>
//         <Routes >
//           <Route path="/" element={(isLoggedIn) ? <Home /> : <Home />} />

//           <Route
//             path="/"
//             element={
//               <Layout />
//             }
//           >

//           </Route>
//           <Route exact path="/dashboard" element={<Home />} />
//           <Route exact path="/tables" element={<Tables />} />

//           {/* <Route exact path="/profile" component={Profile} /> */}
//           {/* <Redirect from="*" to="/dashboard" /> */}

//         </Routes>
//       </BrowserRouter>
//       {/* <Switch>

//       </Switch> */}
//     </div>
//   );
// }

// const Layout = () => {
//   return (
//     <Main> <Outlet />  </Main>
//   )
// }

export default App;